import * as CryptoJS from 'crypto-js';
export class Security
{
    static secretKey:string = "BART2020#APPLICATION";
    public static encrypt(value : string) : string{
        return CryptoJS.AES.encrypt(value, Security.secretKey.trim()).toString();
      }
      public static decrypt(textToDecrypt : string){
        return CryptoJS.AES.decrypt(textToDecrypt, Security.secretKey.trim()).toString(CryptoJS.enc.Utf8);
      }

}
